/// <reference path="../../Scripts/typings/jquery/jquery.d.ts" />
/// <reference path="../../Scripts/typings/q/Q.d.ts" />
/// <reference path="../../Scripts/typings/linq/linq.d.ts" />
/// <reference path="../../Scripts/typings/jquery.base64/jquery.base64.d.ts" />
define('services/applicationstorage',["require", "exports", "models/portal", "models/account", "common/constants", "services/httpclient"], function (require, exports, Portal, Account, constants, http) {
    "use strict";
    var ApplicationStorage = (function () {
        function ApplicationStorage() {
        }
        ApplicationStorage.prototype.readMine = function () {
            var service = new http.Channel();
            if (ApplicationStorage._items != null) {
                return Promise.resolve(ApplicationStorage._items);
            }
            return new Promise(function (resolve, reject) {
                Q(service.getData("/activation/api/shop-item", http.ServiceTarget.oneClickServiceApi))
                    .then(function (data) {
                    var source = Enumerable.From(data)
                        .Select(function (itm) { return Portal.ModuleInfo.from(itm); })
                        .ToArray();
                    // TODO: nur so lange SL und HTML parallel verwendet werden !!!#
                    var user = Account.Principal.current;
                    if (user.memberType != constants.NetworkMemberTypes.PortalAdmin) {
                        source = Enumerable.From(source)
                            .Where(function (app) { return app.configuration.area != null || app.template.target.indexOf("Addison") !== 0; })
                            .ToArray();
                    }
                    ApplicationStorage._items = source;
                    resolve(source);
                })
                    .catch(function (error) { return reject(error); });
            });
        };
        ApplicationStorage.prototype.clear = function () {
            ApplicationStorage._items = null;
        };
        ApplicationStorage.prototype.getSettings = function (moduleName) {
            if (ApplicationStorage._items == undefined)
                return null;
            if (moduleName === "")
                return null;
            var item = Enumerable.From(ApplicationStorage._items)
                .Where(function (i) { return i.name.replace(/ /g, "").replace(/\//g, "").toLowerCase() === moduleName; })
                .FirstOrDefault(null);
            if (item != null) {
                return item.settingsXml;
            }
            return null;
        };
        return ApplicationStorage;
    }());
    return ApplicationStorage;
});

